// src/components/RadarChart.js
import React from "react";
import { Radar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend,
  Title,
} from "chart.js";

// Registrar los elementos necesarios
ChartJS.register(
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend,
  Title
);

// Función para generar datos aleatorios
const randomData = (count) =>
  Array.from({ length: count }, () => Math.floor(Math.random() * 100));

// Etiquetas de ejemplo
const labels = ["January", "February", "March", "April", "May", "June", "July"];

// Datos del gráfico
const data = {
  labels,
  datasets: [
    {
      label: "Dataset 1",
      data: randomData(7),
      borderColor: "rgb(255, 99, 132)",
      backgroundColor: "rgba(255, 99, 132, 0.5)",
    },
    {
      label: "Dataset 2",
      data: randomData(7),
      borderColor: "rgb(54, 162, 235)",
      backgroundColor: "rgba(54, 162, 235, 0.5)",
    },
  ],
};

// Opciones del gráfico
const options = {
  responsive: true,
  plugins: {
    title: {
      display: true,
      text: "Chart.js Radar Chart",
    },
  },
};

const Chart2 = () => {
  return <Radar data={data} options={options} />;
};

export default Chart2;
